import { Link } from 'react-router-dom';
import { ROUTES } from '../../utils/constants.js';
import './NotFound.css';
import Error404Icon from '../../assets/icons/error404.svg?react';
import Error403Icon from '../../assets/icons/error403.svg?react';
const NotFound = ({ code }) => {
  return (
    <div className="not-found-container">
      {code === '403' ? (
        <>
        <Error403Icon />
        <p className="error-code my-12">403</p>
        <h2 className="text-h2 text-gray-800 my-10">접근 권한이 없습니다</h2>
        <div className='flex flex-col justify-center align-center'>
          <p className="text-b2-400 text-gray-700">해당 페이지에 대한 엑세스 권한이 없습니다.</p>
          <p className="text-b2-400 text-gray-700">관리자로부터 권한을 받아야 하며 요청이 승인되면 이 페이지에 엑세스할 수 있습니다.</p>
        </div>
        </>
      ):
      (
        <>
          <Error404Icon />
          <p className="error-code my-12">404</p>
          <h2 className="text-h2 text-gray-800 my-10">페이지를 찾을 수 없습니다</h2>
          <div className='flex flex-col justify-center align-center'>
            <p className="text-b2-400 text-gray-700">페이지가 존재하지 않거나 사용할 수 없는 페이지입니다.</p>
            <p className="text-b2-400 text-gray-700">존재하지 않는 주소를 입력하셨거나 요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.</p>
          </div>

        </>
      )}
      <div className="error-actions mt-12">
        <Link to={ROUTES.HOME} className="btn big-btn btn-primary">
          메인 화면
        </Link>
        <button 
          onClick={() => window.history.back()} 
          className="btn big-btn btn-style-5"
        >
          이전 페이지
        </button>
      </div>
    </div>
  );
};

export default NotFound; 